import { SVGProps } from 'react';
const InfoIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width || '16'}
      height={props.height || '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.00001 11.1999C7.66864 11.1999 7.40002 10.9313 7.40002 10.5999L7.40007 7.79989C7.40008 7.46852 7.66871 7.1999 8.00008 7.1999C8.33145 7.19991 8.60008 7.46854 8.60007 7.79991L8.60002 10.5999C8.60002 10.9313 8.33138 11.1999 8.00001 11.1999Z"
        fill="#8A8A8A"
      />
      <path
        d="M7.20002 5.5999C7.20002 5.15807 7.5582 4.7999 8.00002 4.7999C8.44185 4.7999 8.80003 5.15807 8.80003 5.5999C8.80003 6.04173 8.44185 6.3999 8.00002 6.3999C7.5582 6.3999 7.20002 6.04173 7.20002 5.5999Z"
        fill="#8A8A8A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6 7.9999C13.6 11.0927 11.0928 13.5999 8.00002 13.5999C4.90723 13.5999 2.40002 11.0927 2.40002 7.9999C2.40002 4.90711 4.90723 2.3999 8.00002 2.3999C11.0928 2.3999 13.6 4.90711 13.6 7.9999ZM12.4 7.9999C12.4 10.43 10.4301 12.3999 8.00002 12.3999C5.56997 12.3999 3.60002 10.43 3.60002 7.9999C3.60002 5.56985 5.56997 3.5999 8.00002 3.5999C10.4301 3.5999 12.4 5.56985 12.4 7.9999Z"
        fill="#8A8A8A"
      />
    </svg>
  );
};
export default InfoIcon;
